module.exports = "/_next/static/images/harajuku_gattsuri-top-74e41c5ff0387ed6f0331110162dc8a5.jpg";